const BLOCKQUOTE_REGEX = /<blockquote[^>]*>([\s\S]*?)<\/blockquote>/gi;

function decodeEntities(input: string): string {
	return input
		.replace(/&lt;/g, "<")
		.replace(/&gt;/g, ">")
		.replace(/&quot;/g, '"')
		.replace(/&#39;/g, "'")
		.replace(/&amp;/g, "&");
}

/**
 * Zamienia surowe bloki HTML <blockquote> na markdownowy cytat (`>`),
 * dzięki czemu markdown w środku (np. **pogrubienie**, listy) jest parsowany.
 *
 * react-markdown + rehypeRaw nie parsuje składni markdown wewnątrz bloków
 * surowego HTML (zgodnie z CommonMark), więc bez tej normalizacji pogrubienia
 * w cytatach pozostają jako literalne "**...**".
 */
export function normalizeAiMarkdown(input: string | null | undefined): string {
	if (!input) return "";

	return input.replace(BLOCKQUOTE_REGEX, (_match, rawContent: string) => {
		const content = decodeEntities(rawContent)
			.replace(/<\/p>\s*<p[^>]*>/gi, "\n\n")
			.replace(/<p[^>]*>/gi, "")
			.replace(/<\/p>/gi, "")
			.replace(/<br\s*\/?>/gi, "\n")
			.trim();

		const quoted = content
			.split("\n")
			.map((line) => `> ${line}`.trimEnd())
			.join("\n");

		return `\n\n${quoted}\n\n`;
	});
}
